module.exports = __webpack_public_path__ + "assets/textures/violin_tex_color.5a5fd143e1b9014eed2023f2eff8721c.jpg";